'use client'

import type { TFormField } from '@/components/project/ai-chat/editor/_types'
import { FormFieldDialog } from './form-field-dialog'

interface EditFormCustomFieldDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  field: TFormField
  schemaId: string
  onSuccess: (updatedTree?: any) => void
}

// Wrapper component for backward compatibility
export function EditFormCustomFieldDialog({
  field,
  ...props
}: EditFormCustomFieldDialogProps) {
  return <FormFieldDialog {...props} field={field} mode="edit" />
}
